<style src="./Simple.scss" lang="scss"></style>

<script>
	import Icon from '@/components/Icon/Icon';

	export default {
		props: {
			img: String,
			text: String,
			link: {
				href: String,
				target: String,
				login: Boolean
			},
			icon: String,
			iconColor: String,
			orientation: {
				type: String,
				default: 'vertical',
				validator: function(value) {
					return ['vertical', 'horizontal', 'vertical-reverse', 'horizontal-reverse'].indexOf(value) !== -1;
				}
			},
			shape: {
				type: String,
				validator: function(value) {
					return ['rectangle', 'circle'].indexOf(value) !== -1;
				}
			},
			backdrop: String,
			circleColor: String
		},
		components: {
			'hp-icon': Icon
		}
	};
</script>

<template>
	<a :href="link.href" :target="link.target" :data-login="link.login">
		<figure data-component="simple" :data-orientation="orientation" :data-backdrop="backdrop">
			<div v-if="icon" :data-backdrop="circleColor">
				<hp-icon :color="iconColor" :type="icon"></hp-icon>
			</div>
			<img v-else :src="img" :alt="text" :data-shape="shape" />
			<figcaption>{{ text }}</figcaption>
		</figure>
	</a>
</template>
